// extracted by mini-css-extract-plugin
module.exports = {"PlayPauseButton":"styles_PlayPauseButton__ixZX3"};